/* unplugin-vue-components disabled */import __unplugin_components_0 from '~icons/mdi/email';
var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"fab":"","dark":"","small":"","color":"#4a4a4a"},on:{"click":function($event){return _vm.open()}}},[_c(__unplugin_components_0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }